<template>
  <div
    class="card bg-frosted-glass border-0 shadow rounded-lg overflow-hidden set-position"
  >
    <div class="row no-gutters">
      <div class="col-md-6 login-box">
        <div
          class="text-right h-100 col-12 col-md-9 offset-md-3"
          style="padding: 80px 50px 0px 50px;"
        >
          <img src="@/assets/images/cs_logo.png" width="100%" />
          <div class="border-bottom border-light mt-4"></div>
          <h5 class="mt-4 font-weight-light text-light">Hub of Learning</h5>
        </div>
      </div>
      <div class="col-md-6 bg-light py-5 px-3">
        <div class="row">
          <div class="col-12 col-md-10">
            <form class="form-signin" @submit.prevent="login">
              <div class="text-left mb-4">
                <p class="text-secondary">
                  ลงชื่อเข้าสู่ระบบโดยใส่ชื่อผู้ใช้หรืออีเมล และรหัสผ่าน
                </p>
              </div>

              <div class="form-group">
                <input
                  id="inputEmail"
                  v-model="email"
                  type="text"
                  class="form-control form-rounded shadow-sm bg-white pl-4"
                  :class="{ 'is-invalid': hasErrors }"
                  placeholder="ชื่อผู้ใช้ หรือ อีเมล"
                  required="true"
                  autofocus="true"
                  :disabled="isLoading"
                />
              </div>

              <div class="form-group">
                <input
                  id="inputPassword"
                  v-model="password"
                  type="password"
                  class="form-control form-rounded shadow-sm bg-white pl-4"
                  :class="{ 'is-invalid': hasErrors }"
                  placeholder="รหัสผ่าน"
                  required="true"
                  :disabled="isLoading"
                />
                <div v-if="hasErrors" class="invalid-feedback pl-2 text-wrap">
                  <strong style="white-space: pre-line">{{ errorLoginMessage }}</strong>
                </div>
              </div>

              <div v-if="showCaptcha">
                <vue-turnstile
                  ref="turnstile"
                  @verify="onVerify"
                  @expired="onExpired"
                  :sitekey="captchaSiteKey"
                >
                </vue-turnstile>
              </div>

              <button
                class="btn btn-md btn-csq form-rounded shadow-sm mt-4 col-md-7"
                type="submit"
                :disabled="isLoading"
              >
                เข้าสู่ระบบ
                <span
                  v-if="isLoading"
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                <i
                  v-else
                  class="fas fa-long-arrow-alt-right ml-2"
                  aria-hidden="true"
                ></i>
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>

    <otp-verification-modal
      :show="showOtpModal"
      :com-id="otpComId"
      :m-id="otpMId"
      :email="otpEmail"
      @verified="onOtpVerified"
      @close="onOtpClose"
    />
  </div>
</template>

<script>
import VueTurnstile from "@/components/shared/VueTurnstile";
import OtpVerificationModal from "@/components/pages/login/OtpVerificationModal";

export default {
  data() {
    return {
      email: "",
      password: "",
      hasErrors: false,
      errorLoginMessage: "",
      isLoading: false,
      loginAttempts: 0,
      showCaptcha: false,
      captchaSiteKey: process.env.VUE_APP_TURNSTILE_SITEKEY,
      captchaVerify: false,
      showOtpModal: false,
      otpComId: null,
      otpMId: null,
      otpEmail: "",
      // Holds the validated login response in memory until OTP verification.
      pendingSession: null
    };
  },
  components: {
    "vue-turnstile": VueTurnstile,
    "otp-verification-modal": OtpVerificationModal
  },
  methods: {
    login: function() {
      this.isLoading = true;
      let email = this.email;
      let password = this.password;
      if (
        this.showCaptcha == false ||
        (this.showCaptcha == true && this.captchaVerify == true)
      ) {
        this.$store
          .dispatch("Authentication/login", { email, password })
          .then(resp => {
            this.hasErrors = false;
            this.isLoading = false;
            // Credentials valid — hold the session in memory and gate access
            // behind 2-step (OTP) verification. Nothing is persisted yet.
            const data = resp.data;
            this.pendingSession = data;
            this.otpComId = data.user.profiles[0].company.id;
            this.otpMId = data.user.id;
            this.otpEmail = data.user.email || this.email;
            this.showOtpModal = true;
          })
          .catch(error => {
            if (this.showCaptcha == true) {
              this.$refs.turnstile.reset();
              this.captchaVerify = false;
            }
            this.loginAttempts++;
            this.isLoading = false;
            this.hasErrors = true;
            if (this.loginAttempts >= 1) {
              this.showCaptcha = true;
            }
            if (error.response?.status === 423) {
              this.errorLoginMessage =
                "บัญชีของคุณถูกล็อกชั่วคราว เนื่องจากกรอกรหัสผ่านผิดเกินจำนวนที่กำหนด\nกรุณาลองใหม่ภายหลัง";
            } else {
              this.errorLoginMessage =
                "ชื่อผู้ใช้งานหรือรหัสผ่านไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง";
            }
          });
      } else {
        this.loginAttempts++;
        this.isLoading = false;
        this.hasErrors = false;
      }
    },
    onVerify: function() {
      return (this.captchaVerify = true);
    },
    onExpired: function() {
      console.log("Expired");
    },
    onOtpVerified: async function() {
      this.showOtpModal = false;
      // Second factor passed — now establish the authenticated session.
      await this.$store.dispatch(
        "Authentication/persistSession",
        this.pendingSession
      );
      const profile = this.pendingSession.user.profiles[0];
      this.pendingSession = null;
      if (profile.strongPasswordAt === null) {
        window.location.href = "/reset-password";
      } else {
        window.location.href = "/" + profile.company.url;
      }
    },
    onOtpClose: function() {
      // User dismissed the OTP step before verifying. No session was
      // persisted, so simply discard the in-memory credentials.
      this.showOtpModal = false;
      this.pendingSession = null;
    }
  }
};
</script>

<style lang="css" scoped>
.form-rounded {
  border-radius: 2rem;
}

.btn-csq {
  font-family: "Prompt", sans-serif;
  color: #f9fafb;
  background-color: #df812f;
  border-color: #e67424;
}

.btn-csq:hover {
  color: #f9fafb;
  background-color: #f3801c;
  border-color: #f3801c;
}

.text-csq {
  color: #df812f;
}

.login-box {
  padding-top: 5rem !important;
  padding-bottom: 5rem !important;
}

.text-secondary {
  font-family: "Prompt", sans-serif;
}

.set-position {
  margin-top: -9rem !important;
}
</style>
